import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MapPin, ArrowUpRight } from "lucide-react";
import { SITE } from "@/config/site";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-navy px-6 pt-24 text-white md:px-12 lg:px-16" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px]">
        <div className="grid gap-16 pb-20 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src="/bwt-logo.png" alt="BWT" className="h-12 w-12 rounded-full bg-white/95 p-1 object-contain" />
              <span className="font-display text-xl font-extrabold tracking-tight">BWT</span>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/60">
              Brahmandnayak World Trade connects premium Indian textiles with global markets — export,
              domestic supply and factory-direct sourcing, built on four decades of textile craft.
            </p>
          </div>

          <div>
            <h4 className="font-display text-xs font-bold uppercase tracking-[0.24em] text-sky">Explore</h4>
            <ul className="mt-6 space-y-3 text-sm text-white/70">
              <li><Link to="/" className="transition-colors hover:text-white">Home</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-white">About Us</Link></li>
              <li><Link to="/products" className="transition-colors hover:text-white">Products</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xs font-bold uppercase tracking-[0.24em] text-sky">Trade</h4>
            <ul className="mt-6 space-y-3 text-sm text-white/70">
              <li>Export Trade</li>
              <li>Domestic Supply</li>
              <li>Sourcing & Supply</li>
              <li>Bulk Orders</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xs font-bold uppercase tracking-[0.24em] text-sky">Get in touch</h4>
            <ul className="mt-6 space-y-4 text-sm text-white/70">
              <li>
                <a href={SITE.phoneHref} className="group flex items-center gap-3 transition-colors hover:text-white" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-sky" /> {SITE.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="group flex items-center gap-3 break-all transition-colors hover:text-white" data-testid="footer-email">
                  <Mail className="h-4 w-4 shrink-0 text-sky" /> {SITE.email}
                </a>
              </li>
              <li>
                <a href={SITE.instagram} target="_blank" rel="noreferrer" className="group flex items-center gap-3 transition-colors hover:text-white" data-testid="footer-instagram">
                  <Instagram className="h-4 w-4 text-sky" /> @bwtuniverse_
                </a>
              </li>
              <li>
                <a href={SITE.location} target="_blank" rel="noreferrer" className="group flex items-center gap-3 transition-colors hover:text-white" data-testid="footer-location">
                  <MapPin className="h-4 w-4 text-sky" /> View location <ArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-4 border-t border-white/10 py-8 text-xs text-white/40 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Brahmandnayak World Trade. All rights reserved.</p>
          <p className="font-display uppercase tracking-[0.24em]">India to the World. Built for Global Trade.</p>
        </div>
      </div>

      <div aria-hidden className="pointer-events-none select-none text-center">
        <span className="block font-display font-black leading-[0.8] text-white/[0.04]" style={{ fontSize: "24vw" }}>
          BWT
        </span>
      </div>
    </footer>
  );
};
